import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const ReportsRouter = {
  path: '/reports',
  component: Management,
  redirect: '/reports/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/reports/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.common
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/reports/ListTable'),
          meta: {
            auth: Auth.common,
            tabName: 'all'
          }
        }
      ]
    },
    {
      path: 'new',
      component: () => import('@/views/reports/New'),
      meta: {
        auth: Auth.common
      }
    }
  ]
}

export default ReportsRouter
